import * as React from "react";
const SvgIcSelectArrowUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 10L8 6L4 10", stroke: "#A1A7B2", strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgIcSelectArrowUp;
